import { DialogClassKey } from "@material-ui/core/Dialog"
import { CSSProperties } from "@material-ui/styles"
import { MakeOptional } from "typescript/utils"

export type TDialogWidthClassKey = Extract<
  DialogClassKey,
  "paperWidthXs" | "paperWidthSm" | "paperWidthMd" | "paperWidthLg" | "paperWidthXl"
>
export type IMuiDialog = {
  [K in DialogClassKey]: CSSProperties
}

export type TMuiDialog = MakeOptional<IMuiDialog, "root">

export const MuiDialog = {
  paperWidthXs: {
    maxWidth: "44.4rem",
  },
  paperWidthSm: {
    maxWidth: "60rem",
  },
  paperWidthMd: {
    maxWidth: "90rem",
  },
  paperWidthLg: {
    maxWidth: "110rem",
  },
  paperWidthXl: {
    maxWidth: "192rem",
  },
  paper: {
    "overflow-y": "visible",
  },
}
